import 'bootstrap';
import CUSTOMIZE from "./extended_class/customize";
import HOME from './modules/home';
import ABOUT from './modules/about';
import LP from './modules/lp';

const [ d ] = [ document ];

const TPL = new CUSTOMIZE();

d.addEventListener('DOMContentLoaded', () => {
  const bodyClass = d.body.classList;
  const pathname= location.pathname;

  d.body.style.cssText = 'transition-duration: 0.2s;';
  setTimeout( () => d.body.style.cssText = '', 200 );

  switch( true ) {
    case bodyClass.contains('is--index') : HOME(); break
    case pathname.includes('pages/about') : ABOUT(); break
    case pathname.includes('pages/lp') : LP(); break
  }
});

TPL.init();